import type { CarbonIconType } from '@carbon/icons-react';
import styles from './SettingsSectionItem.module.scss';

export interface SettingsSectionItemProps {
  icon?: CarbonIconType;
  label: string;
  /** Pour relier un contrôle (ex. Toggle) via `aria-labelledby` */
  labelId?: string;
  sublabel?: React.ReactNode;
  labelSuffix?: React.ReactNode;
  action: React.ReactNode;
  variant?: 'default' | 'danger';
}

export function SettingsSectionItem({
  icon: Icon,
  label,
  labelId,
  sublabel,
  labelSuffix,
  action,
  variant = 'default',
}: SettingsSectionItemProps) {
  return (
    <div className={`${styles.item} ${variant === 'danger' ? styles.itemDanger : ''}`}>
      <div className={styles.itemContent}>
        {Icon && (
          <div className={styles.iconWrapper}>
            <Icon size={20} className={styles.icon} />
          </div>
        )}
        <div>
          <div className={styles.labelRow}>
            <span className={styles.label} id={labelId}>
              {label}
            </span>
            {labelSuffix}
          </div>
          {sublabel && <div className={styles.sublabel}>{sublabel}</div>}
        </div>
      </div>
      {action}
    </div>
  );
}
